import { render, staticRenderFns } from "./YAlert.vue?vue&type=template&id=37f26a92&scoped=true"
import script from "./YAlert.vue?vue&type=script&lang=js"
export * from "./YAlert.vue?vue&type=script&lang=js"
import style0 from "./YAlert.vue?vue&type=style&index=0&id=37f26a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f26a92",
  null
  
)

export default component.exports